<template>
  <el-table
    :data="locations"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'value', order: 'ascending'}"
  >
    <el-table-column
      prop="value"
      label="Terület"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :location="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      locations() {
        return this.$store.getters['location/locations'];
      },

      loading() {
        return this.$store.getters['location/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('location/fetchAll');
    },

  }
</script>
